import logoImg from "/logo/logo.png";
import office from "/officepic.jpg";
import image2 from "/image-2.webp";
import marathon from "/marathon4.jpg";
import marathon2 from "/marathon2.webp";
import amore1 from "/amore1.webp";
import image from "/image.webp";
import andheri3 from "/andheri3.webp";
import img from "/img.webp";
import diamond3 from "/diamond3.webp";
import amore3 from "/amore3.webp";
import matulya4 from "/matulya4.webp";
import MakhijaConf from "/officeimg/Makhija/Makhija.JPG";
import tradelinkImg from "/officeimg/Tradelink/tradelink1.jpg";
import martathonIMg from "/officeimg/MarathonFuturex/marathon1.jpeg";

import newPhoto1 from "/photo1.jpg";
import newPhoto2 from "/photo2.jpg";
import newPhoto3 from "/photo3.jpg";
import newPhoto4 from "/photo4.jpg";
import newPhoto5 from "/photo5.jpg";
import newPhoto6 from "/photo6.jpeg";
import newPhoto7 from "/aspectHome.jpeg";

// home images
import home1 from "/privateOffices.jpg";
import home2 from "/MeetingRoomHome.jpg";
import home3 from "/Homepageicon1.png";

import Marathon1 from "/Marathon.webp";
import Marathon2 from "/MarathonFuturex.webp";

export const logo = logoImg;
export const office_main = "";
export const office_pic = office;
export const photo1 = home1;
export const photo2 = home2;
export const photo3 = image2;
export const photo4 = home3;

export const gallery1 = marathon;
export const gallery2 = marathon2;
export const gallery3 = amore1;
export const gallery4 = image;
export const gallery5 = andheri3;
export const gallery6 = img;
export const gallery7 = diamond3;
export const gallery8 = amore3;
export const gallery9 = matulya4;

export const gallery10 = MakhijaConf;
export const gallery11 = tradelinkImg;
export const gallery12 = martathonIMg;

export const gallery13 = newPhoto1;
export const gallery14 = newPhoto2;
export const gallery15 = newPhoto3;
export const gallery16 = newPhoto4;
export const gallery17 = newPhoto5;
export const gallery18 = newPhoto6;

export const gallery19 = newPhoto7;
export const gallery20 = Marathon1;
export const gallery21 = Marathon2;

export const background2 = "https://www.603thecoworkingspace.com/#lg=1&slide=0";
export const vid = "https://videos.files.wordpress.com/he8mF3Bd/about.mp4";
